import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { BuildingSelectFormikField } from '../../Building'
import { LISTING_FORM_FIELD_NAME_BUILDING } from '../RentalPortalListing.constants'

function RentalPortalListingBuildingField({ Field, borderless, isLoading }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <BuildingSelectFormikField
      Field={Field}
      controlProps={{
        borderless: borderless ?? !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('RentalPortal.ListingBuildingFilterPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        isLoading,
        label: `${t('RentalPortal.ListingFormBuildingLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={LISTING_FORM_FIELD_NAME_BUILDING}
    />
  )
}

export default RentalPortalListingBuildingField
